import { GroupedChoiceList } from 'types/Question';
import { ProgramMembership } from './Membership';

export enum ApplicationRoleEnum {
	MENTOR = 'mentor',
	MENTEE = 'mentee',
}

export type ApplicationRole = 'mentor' | 'mentee' | 'peer';

export interface Attachment {
	name: string;
	url: string;
	questionId: number;
}

export interface ApplicationAnswersStats {
	applicationId: number;
	pairLimit: number;
	position: string;
}

export interface ApplicationStats {
	applicationId: number;
	generatedPairsCount: number;
	withEntryMeetingPairsCount: number;
	acceptedPairsCount: number;
	lastLoginDateDays: number | null;
}

export interface ApplicationLimitStats {
	applicationId: number;
	currentPairs: number;
	pairLimitReached: boolean;
}

export interface Application {
	id: number;
	applicationRole: ApplicationRole;
	answers: Answer[];
	systemAnswers: {
		areas: GroupedChoiceList[];
		department: string;
		email: string;
		linkedin: string;
		name: string;
		position: string;
		surname: string;
		expectations: string;
		pairLimit: string;
		avatar: string;
		attachments: Attachment[];
		phone: string;
	};
	approved: 'not accepted' | 'accepted' | 'rejected';
	rejectReason: string | null;
	programId: number;
	programMembershipId: number;
	programMembership: ProgramMembership;
	createdAt: string;
	finished: boolean;
	label: any;
	labelData: any;
	applicationHash: string | null;
	deletedAt: Date | null;
	stats?: ApplicationStats;
	pairLimit: number;
	limitStats?: ApplicationLimitStats;
	answersStats?: ApplicationAnswersStats;
}

export interface ApplicationWithContactInfo extends Application {
	inPairing: boolean;
}

export interface Answer {
	moptions: string[] | null;
	mgoptions?: GroupedChoiceList[] | null;
	value?: string | boolean | number | null;
	signedUrl?: null | { inline: string; attachment: string };
	questionId: number;
	question: {
		priority: number;
		questionType: string;
		systemQuestionType: string;
		text: string;
		hiddenFromUsers?: boolean;
		description?: string;
	};
}
